import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import { trainingApi } from "../../services";
import { useFormik } from "formik";
import { toast } from "react-toastify";

export default function TrfApproval() {
  const { id } = useParams();
  const [date, setDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [trainingData, SetTrainingData] = useState();
  const categories = [
    { name: "Technical", code: "TEC" },
    { name: "Functional", code: "FUNC" },
    { name: "Behavioral", code: "BEH" },
    { name: "Soft Skills", code: "SS" },
  ];
  const [selectedTechnology, setSelectedTechnology] = useState(null);
  const technologies = [
    { name: "React JS", code: "REC" },
    { name: "Node JS", code: "NODE" },
    { name: "JavaScript", code: "JS" },
    { name: "Phython", code: "PHY" },
  ];
  const [selectedStatus, setSelectedStatus] = useState(null);
  const currentstatus = [
    { name: "Billable", code: "BILL" },
    { name: "Shadow", code: "SDW" },
    { name: "Blocked", code: "BLK" },
    { name: "Bench", code: "BEN" },
  ];
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [rowClick, setRowClick] = useState(true);
  const formik = useFormik({
    initialValues: {
      targetSkill: "",
      nameOfNominatedParticipant: "",
      categoryOfTraining: "",
      comments: "",
      ProjectName:""

    },
    validate: (data) => {
      let errors = {};
      if (!data.skills) {
        errors.skills = "Skill is required.";
      }
      return errors;
    },
    onSubmit: (data) => {
      // save(data);
    },
  });
  useEffect(() => {
    const mockProducts = [
      {
        id: 1,
        skills: <b>Current skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
      {
        id: 2,
        skills: <b>Expected skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
    ];
    setProducts(mockProducts);
  }, []);
  useEffect(() => {
    if (id) {
      getTRFDetails(id);
    }
  }, []);

  const getTRFDetails = (id) => {
    trainingApi.fetchTrainingFormByID(id).then((resp) => {
      const result = resp.data.data;
      SetTrainingData(result);
      formik.setFieldValue("targetSkill", result?.targetSkills?.title);
      formik.setFieldValue(
        "nameOfNominatedParticipant",
        result?.nameOfNominatedParticipant
      );
      formik.setFieldValue("categoryOfTraining", result?.categoryOfTrainings?.title);
      formik.setFieldValue("projectName", result?.projectName);
      var Training_startDate = new Date(result?.trainingRequisitionDate);
      var Training_endDate = new Date(result?.endDateOfTraining);
      setStartDate(Training_startDate);
      setEndDate(Training_endDate);
    });
  };

  const handleRadioSelection = (productId, skillLevel) => {
    const updatedProducts = products.map((product) => {
      if (product.id === productId) {
        return {
          ...product,
          beginnerNoKnowledge: skillLevel === "beginnerNoKnowledge",
          beginnerBasicKnowledge: skillLevel === "beginnerBasicKnowledge",
          intermediateGoodKnowledge: skillLevel === "intermediateGoodKnowledge",
          intermediateStrongExperience:
            skillLevel === "intermediateStrongExperience",
          expert: skillLevel === "expert",
        };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const radioTemplate = (skillLevel) => (rowData) =>
    (
      <RadioButton
        inputId={`${rowData.id}-${skillLevel}`}
        checked={rowData[skillLevel]}
        onChange={() => handleRadioSelection(rowData.id, skillLevel)}
      />
    );
  const navigate = useNavigate();

  const purpose = [
    { name: "Strategic - Building Capability Pool", key: "S" },
    {
      name: "Tactical - Continue on same project but with enhanced competency level",
      key: "T",
    },
    {
      name: "Tactical - Deployment on a different project as per the project needs ",
      key: "D",
    },
    {
      name: "Strategic - To be followed with immediate certification for building capability pool",
      key: "R",
    },
    {
      name: "Tactical - To be followed with immediate certification for project needs",
      key: "K",
    },
    { name: "Strategic - Employee Aspiration ", key: "G" },
  ];
  const [selectedCategories, setSelectedCategories] = useState([categories[1]]);

  const onCategoryChange = (e) => {
    let _selectedCategories = [...selectedCategories];

    if (e.checked) _selectedCategories.push(e.value);
    else
      _selectedCategories = _selectedCategories.filter(
        (category) => category.key !== e.value.key
      );

    setSelectedCategories(_selectedCategories);
  };

  const business = [
    { name: "Becoming billable if currently non-billable", key: "B" },
    { name: "Avoid External Hiring and thereby cost effectiveness", key: "A" },
    { name: "Better quality of deliverables / Productivity", key: "P" },
    { name: "Replace internal employee on a lower cost", key: "I" },
    { name: "Hired to train and make billable on project", key: "H" },
    { name: "Capability Building for future projects", key: "C" },
    { name: "Meet Partnership Qualifying Criteria", key: "M" },
    { name: "Utility Training to enable in project", key: "U" },
  ];

  const [approvalStatus, setApprovalStatus] = useState(null);
  const [trainingType, setTrainingType] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [endDate, setEndDate] = useState(null);

  const trainingTypes = [
    { label: "Self-Paced", value: "Self-Paced" },
    { label: "Instructor-Led", value: "Instructor-Led" },
  ];

  const handleStatusChange = (e) => {
    setApprovalStatus(e.value);
    if (e.value === "Rejected") {
      setTrainingType(null);
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleSubmit = () => {
    const dataObj = [
      {
        reason: approvalStatus === "Approved" ? "approve" : "reject",
        status: approvalStatus === "Approved" ? 1 : 2,
        comments: formik.values.comments,
        trainingType: trainingType,
        endDateOfTraining: endDate,
        trainingRequisitionDate: startDate,
        training: [id],
      },
    ];
    try {
      trainingApi.updateTrainingForm(dataObj).then(
        (resp) => {
          console.log(resp);
          toast.success(resp?.data?.message);
          setTimeout(() => {
            navigate("/training-validation",{
              state: { trainingData },
          });

          }, 1000);
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  };

  return (
    <div className="card">
      <div className="col">
        <h1 className="p-0 training-heading">TRF Approval</h1>
        <hr></hr>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Target Skill
          </label>
          <InputText
            name="targetSkill"
            value={formik.values.targetSkill}
            onChange={formik.handleChange}
            disabled
            placeholder="Target Skill"
            className="w-full"
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Project Name
          </label>
          <InputNumber
            disabled
            placeholder=" Project Name"
            className="w-full"
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Employee Name
          </label>
          <InputText
            name="nameOfNominatedParticipant"
            value={formik.values.nameOfNominatedParticipant}
            disabled
            placeholder="Name"
            className="w-full"
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Category Of Training
          </label>
          <InputText
            name="categoryOfTraining"
            value={formik.values.categoryOfTraining}
            disabled
            placeholder="Training"
            className="w-full"
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            TRF Link
          </label>
          <div>
            <a
              label="Open TRF Form"
              className="p-button-sm mt-2 p-button-primary"
              onClick={() => navigate("/trf")}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "#1E90FF",
              }}
            >
              Open TRF
            </a>
          </div>
        </div>
        <div className="col-6">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Approve/Reject
          </label>
          <div className="flex align-items-center">
            <RadioButton
              inputId="approve"
              name="status"
              value="Approved"
              onChange={handleStatusChange}
              checked={approvalStatus === "Approved"}
            />
            <label htmlFor="approve" className="ml-2">
              Approve
            </label>
            <RadioButton
              inputId="reject"
              name="status"
              value="Rejected"
              onChange={handleStatusChange}
              checked={approvalStatus === "Rejected"}
              className="ml-4"
            />
            <label htmlFor="reject" className="ml-2">
              Reject
            </label>
          </div>
        </div>
      </div>
      {approvalStatus === "Approved" && (
        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-6">
            <label
              htmlFor="trainingType"
              className="font-bold block mb-2 training-heading mt-2"
            >
              Training Type
            </label>
            <Dropdown
              id="trainingType"
              value={trainingType}
              options={trainingTypes}
              className="w-full"
              onChange={(e) => setTrainingType(e.value)}
              placeholder="Select Training Type"
            />
          </div>
          <div className="col-6">
            <label
              htmlFor="startDate"
              className="font-bold block mb-2 training-heading mt-2"
            >
              Start Date
            </label>
            <Calendar
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.value)}
              showIcon
              className="w-full requisition-date"
              placeholder="Enter Start Date"
            />
          </div>
          <div className="col-6">
            <label
              htmlFor="endDate"
              className="font-bold block mb-2 training-heading mt-2"
            >
              End Date
            </label>
            <Calendar
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.value)}
              showIcon
              className="w-full requisition-date"
              placeholder="Enter End Date"
            />
          </div>
          <div className="col-6">
            <label
              htmlFor="feedback"
              className="font-bold block mb-2 training-heading mt-2"
            >
              Feedback/Comments
            </label>
            <InputText
              name="comments"
              value={formik.values.comments}
              onChange={formik.handleChange}
              placeholder="Provide feedback"
              required
              style={{ background: "white" }}
              className="w-full"
            />
          </div>
        </div>
      )}
      {approvalStatus === "Rejected" && (
        <div className="col-12">
          <label
            htmlFor="feedback"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Feedback/Comments <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Provide feedback"
            required
            className="w-full"
            style={{ background: "white" }}
          />
        </div>
      )}
      <div className="flex flex-wrap p-field font-bold block mt-4">
        <div className="col-12 flex">
          <Button label="Submit" onClick={handleSubmit} />
          <Button
            label="Back"
            className="ml-1"
            severity="secondary"
            onClick={() => navigate("/trf")}
          />
        </div>
      </div>
    </div>
  );
}
